import { BaseQueryWithValidationClass } from 'src/editor/api/queries/utils/query-with-validation-class'
import {
  getWhiteLabelBrandSettings,
  WhiteLabelBrandSettingsInterface,
  WL_BRAND_SETTINGS_API_URL,
} from 'src/editor/api/white-label-brand-api'

class WhiteLabelBrandSettingsQueryClass extends BaseQueryWithValidationClass<
  [],
  WhiteLabelBrandSettingsInterface
> {
  queryFn = getWhiteLabelBrandSettings
  getQueryKey = () => [WL_BRAND_SETTINGS_API_URL] as const
}
export const whiteLabelBrandSettingsQuery =
  new WhiteLabelBrandSettingsQueryClass()
